if (!customElements.get('stacked-gallery-arrow')) {
            customElements.define(
              'stacked-gallery-arrow',
              class extends HTMLElement {
                connectedCallback() {
                  this.gallery = this.closest('product-images');
                  this.button = this.querySelector('button');
                  this.mediaList = this.gallery?.querySelector(
                    '[data-product-media-list]'
                  );

                  if (!this.gallery || !this.button || !this.mediaList) return;

                  this.desktop = window.matchMedia('(min-width: 750px)');
                  this.reducedMotion = window.matchMedia(
                    '(prefers-reduced-motion: reduce)'
                  );

                  this.scheduleUpdate = () => {
                    if (this.frame) return;

                    this.frame = requestAnimationFrame(() => {
                      this.frame = null;
                      this.update();
                    });
                  };

                  this.handleClick = () => {
                    this.update();

                    if (!this.target || this.button.hidden) return;

                    const destination =
                      window.scrollY +
                      this.target.getBoundingClientRect().top -
                      100;

                    window.scrollTo({
                      top: Math.max(0, destination),
                      behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
                    });
                  };

                  this.button.addEventListener('click', this.handleClick);

                  window.addEventListener('scroll', this.scheduleUpdate, {
                    passive: true
                  });
                  window.addEventListener('resize', this.scheduleUpdate);

                  this.mediaList.addEventListener(
                    'load',
                    this.scheduleUpdate,
                    true
                  );

                  // Observe gallery media, not the arrow's positioning styles.
                  this.mediaObserver = new MutationObserver(this.scheduleUpdate);
                  this.mediaObserver.observe(this.mediaList, {
                    subtree: true,
                    childList: true,
                    attributes: true,
                    attributeFilter: ['class', 'style', 'hidden']
                  });

                  this.galleryObserver = new MutationObserver(this.scheduleUpdate);
                  this.galleryObserver.observe(this.gallery, {
                    attributes: true,
                    attributeFilter: ['class', 'data-active-media']
                  });

                  this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
                  this.resizeObserver.observe(this.mediaList);

                  this.scheduleUpdate();
                }

                getVisibleSlides() {
                  return Array.from(
                    this.mediaList.querySelectorAll('[data-slide]')
                  ).filter(slide => {
                    const style = window.getComputedStyle(slide);
                    const rect = slide.getBoundingClientRect();

                    return (
                      !slide.hidden &&
                      style.display !== 'none' &&
                      style.visibility !== 'hidden' &&
                      Number(style.opacity) > 0 &&
                      rect.width > 0 &&
                      rect.height > 0
                    );
                  });
                }

                update() {
                  this.button.hidden = true;
                  this.target = null;

                  if (!this.desktop.matches) return;

                  const slides = this.getVisibleSlides();
                  if (slides.length < 2) return;

                  const first = slides[0].getBoundingClientRect();
                  const next = slides[1].getBoundingClientRect();
                  const viewportHeight = window.innerHeight;

                  // Show only while the first gallery item is in view.
                  if (first.top >= viewportHeight - 100) return;
                  if (first.bottom <= 160) return;

                  // Hide once the next item moves well into the viewport.
                  if (next.top < viewportHeight * 0.65) return;

                  if (
                    first.right <= 0 ||
                    first.left >= window.innerWidth
                  ) return;

                  // Position 20px above the visible first-image area's bottom.
                  const visibleBottom = Math.min(
                    first.bottom,
                    viewportHeight
                  );
                  const buttonTop = visibleBottom - 64;

                  if (buttonTop < Math.max(first.top + 16, 100)) return;

                  this.target = slides[1];
                  this.button.style.left =
                    `${first.left + first.width / 2}px`;
                  this.button.style.top = `${buttonTop}px`;
                  this.button.hidden = false;
                }

                disconnectedCallback() {
                  if (this.frame) cancelAnimationFrame(this.frame);

                  this.mediaObserver?.disconnect();
                  this.galleryObserver?.disconnect();
                  this.resizeObserver?.disconnect();

                  window.removeEventListener('scroll', this.scheduleUpdate);
                  window.removeEventListener('resize', this.scheduleUpdate);

                  this.mediaList?.removeEventListener(
                    'load',
                    this.scheduleUpdate,
                    true
                  );

                  this.button?.removeEventListener(
                    'click',
                    this.handleClick
                  );
                }
              }
            );
          }